import { UserFieldErrorMessages } from "@constants/Errors";
import {
  handleNumericalFieldChange,
  phoneNumberChange,
} from "@services/ErrorHandling";
import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { USER } from "@types/user";
import { USER_TYPE, USER_TYPE_STRING } from "@constants/Enums";

type UserAccountInfoCardProps = {
  userData: USER;
  errors: any;
  updateUserData: (field: string, value: any) => void;
  updateError: (field: string, value: any) => void;
  adminRoleSelected: boolean;
  contactRoleSelected: boolean;
  hasKakelyLicense: boolean;
  hasYobelyLicense: boolean;
  createUser: boolean;
};

export const UserAccountInfoCard = ({
  userData,
  errors,
  updateUserData,
  updateError,
  adminRoleSelected,
  hasKakelyLicense,
  hasYobelyLicense,
  contactRoleSelected,
  createUser,
}: UserAccountInfoCardProps) => {
  return (
    <div>
      <TextInputField
        label="メールアドレス 1"
        value={userData?.email}
        placeholder="example@example.com"
        onChange={(e) => updateUserData("email", e.target.value)}
        required={adminRoleSelected}
      />
      {errors.email_exists && (
        <p className="text-red-500">
          {UserFieldErrorMessages.emailExistsError}
        </p>
      )}

      <div className="mt-5 divider" />

      <TextInputField
        label="メールアドレス 2"
        value={userData?.secondary_email}
        placeholder="example@example.com"
        onChange={(e) => updateUserData("secondary_email", e.target.value)}
      />
      {errors.email_exists && (
        <p className="text-red-500">
          {UserFieldErrorMessages.emailExistsError}
        </p>
      )}

      <div className="mt-5 divider" />

      <TextInputField
        label="電話番号１（ハイフンなし）"
        value={userData?.personal_tel}
        required={hasKakelyLicense && !contactRoleSelected}
        placeholder="（例）08012345678"
        onChange={(e) => {
          phoneNumberChange(
            "personal_tel",
            e.target.value,
            updateUserData,
            updateError,
            createUser ? 1 : userData?.user_type,
          );
        }}
        type={"tel"}
      />

      {errors.personal_tel && (
        <p className="text-red-500">
          {createUser ||
          userData?.user_type == USER_TYPE.EXTERNAL ||
          userData?.user_type == USER_TYPE.INTERNAL ||
          userData?.user_type == USER_TYPE_STRING.EXTERNAL ||
          userData?.user_type == USER_TYPE_STRING.INTERNAL
            ? UserFieldErrorMessages.telephoneNumberError
            : UserFieldErrorMessages.telephoneNumberErrorNoLimit}
        </p>
      )}
      <div className="mt-5 divider"></div>

      <TextInputField
        label="電話番号２（ハイフンなし）"
        value={userData?.secondary_phone_number}
        placeholder="（例）08012345678"
        onChange={(e) => {
          phoneNumberChange(
            "secondary_phone_number",
            e.target.value,
            updateUserData,
            updateError,
            createUser ? 1 : userData?.user_type,
          );
        }}
      />

      {errors.secondary_phone_number && (
        <p className="text-red-500">
          {createUser ||
          userData?.user_type == USER_TYPE.EXTERNAL ||
          userData?.user_type == USER_TYPE.INTERNAL ||
          userData?.user_type == USER_TYPE_STRING.EXTERNAL ||
          userData?.user_type == USER_TYPE_STRING.INTERNAL
            ? UserFieldErrorMessages.telephoneNumberError
            : UserFieldErrorMessages.telephoneNumberErrorNoLimit}
        </p>
      )}
      <div className="mt-5 divider"></div>
    </div>
  );
};
